export function Field({ label, children, required, hint }) {
  return (
    <label className="block">
      <span className="font-body text-sm text-brand-slate">
        {label}{required && <span className="text-brand-lavender-dark"> *</span>}
      </span>
      <div className="mt-2">{children}</div>
      {hint && <span className="font-body text-xs text-brand-slate/70 mt-1 block">{hint}</span>}
    </label>
  );
}

const base =
  "w-full bg-transparent border-0 border-b border-brand-line rounded-none focus:outline-none focus:ring-0 focus:border-brand-forest px-0 py-3 font-body text-brand-ink placeholder:text-brand-slate/40 transition-colors";

export function TextInput(props) {
  return <input {...props} className={`${base} ${props.className || ""}`} />;
}

export function TextArea(props) {
  return <textarea {...props} className={`${base} resize-none ${props.className || ""}`} />;
}

export function SelectInput({ children, ...props }) {
  return (
    <select {...props} className={`${base} ${props.className || ""}`}>
      {children}
    </select>
  );
}
